module.exports = __webpack_public_path__ + "img/selected6-min.1a07daf6.png";